import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layerButtonCont d-flex justify-start align-center"},[_c(VBtn,{staticClass:"btn",attrs:{"text":"","rounded":""}},[_c(VIcon,{staticClass:"mr-3"},[_vm._v(" mdi-plus-circle ")]),_vm._v(" Add New Layer ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }